import { RouteName } from "../RouteNames";

export const settingsRoutes = {
  name: RouteName.UserSettingsRoot,
  path: "/user-settings",
  component: () =>
    import(
      "@follaw-fr/views/top_menu_views/user_settings/UserSettingsView.vue"
    ),
  children: [
    {
      name: RouteName.UserSettingsAccount,
      path: "account",
      component: () =>
        import(
          "@follaw-fr/components/user-settings/molecules/UserProfileForm.vue"
        ),
    },
    {
      name: RouteName.UserSettingsSubscription,
      path: "subscription",
      component: () =>
        import(
          "@follaw-fr/components/user-settings/molecules/SubscriptionForm.vue"
        ),
    },
    {
      name: RouteName.UserSettingsNotifications,
      path: "notifications",
      component: () =>
        import(
          "@follaw-fr/components/user-settings/molecules/AlertSettings.vue"
        ),
    },
  ],
};
